// Redux.
import { connect } from 'react-redux';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AlgoliaSearch from '../components/AlgoliaSearch';
import TopSpeakerTopics from '../components/TopSpeakerTopics';
import SearchBoxWithSuggestions from '../components/SearchBoxWithSuggestions';
import BottomMenu from '../components/BottomMenu';
import { SearchActivityProvider } from '../components/SearchActivity';
import {
    addRecentSearch,
    clearRecentSearches,
    compactSearchQuery,
    readRecentSearches,
    removeRecentSearch,
} from '../utils/searchLanding';
import { useEffect, useState } from 'react';

export const Search = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [recentSearches, setRecentSearches] = useState(readRecentSearches);

    useEffect(() => {
        document.getElementById('audio')?.pause();
    }, []);

    const querySelected = (query) => {
        const compactedQuery = compactSearchQuery(query);
        if (!compactedQuery) {
            navigate(`/search${location.search}`);
            return;
        }
        setRecentSearches(addRecentSearch(compactedQuery));

        navigate(`/search/${encodeURIComponent(compactedQuery)}${location.search}`);
    }

    const noQueryView = (
        <TopSpeakerTopics
            recentSearches={recentSearches}
            onTopicSearch={querySelected}
            onRecentSearchClick={querySelected}
            onRecentSearchRemove={(query) => {
                setRecentSearches(removeRecentSearch(query));
            }}
            onRecentSearchesClear={() => {
                setRecentSearches(clearRecentSearches());
            }}
        />
    )

    return (
        <SearchActivityProvider>
            <div id="searchContainer" className='container hideScrollbar hasBottomMenu appScreen' style={{ height: 'var(--app-height, 100svh)' }}>
                <div className='horizontalCenter'>
                    <AlgoliaSearch
                        noQueryView={noQueryView}
                        initialQuery={params.query}
                        initialTab={searchParams.get('tab') || 'podcasts'}
                        searchBox={<SearchBoxWithSuggestions querySelected={querySelected} initialQuery={params.query} />}
                    />
                </div>
                <BottomMenu />
            </div>
        </SearchActivityProvider>
    );
};

const mapStateToProps = (state) => ({
});

const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(Search);
